import React from "react";
import {useDispatch, useSelector} from "react-redux";

const UserFilterSoc = () => {

    const dispatch = useDispatch();
    const soc = useSelector((state) => state.soc);

    const onChange = (e) => {
        dispatch({type: 'SET_ADMIN_SOC', payload: e.target.value});
    }

    return (
        <>
            <input className="form-control" onChange={e => onChange(e)} />
        </>
    );
};

export default UserFilterSoc;